import React from "react";
import "./Projects.css";
import { Pj } from "./Pj";
import { holeThing } from "../../constants/containts";
export const Projects = () => {
  return (
    <>
      <div className="section">
        <h2 className="section__title different" data-aos="fade-right">
          Projects
        </h2>
        {
          holeThing.map((item) => <Pj key={Math.random()} {...item}/>)
        }
      </div>
    </>
  );
};
